<template>
    <div v-if="amount > 0">
        <div class="documents-to-acknowledge hidden-mobile" :class="{ warning: requires }">
          <heading colour="white" size="medium" no-margin>{{ amount }} Documents Require Acknowledgement</heading>
            <p>There are {{ amount }} documents awaiting your acknowledgement.</p>
            <a :href="url">View Docs</a>
        </div>
        <div class="hidden-desktop dashboard-component-icon" :class="{ warning: requires }">
          <heading colour="white" size="medium">Documents</heading>
            <a :href="url"><i class="fa fa-file-text"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {}
        },
        props: ['url'],
        computed: {
            amount: function(){
                return parseInt(parseInt(appData.user.documents.required,10) + parseInt(appData.user.documents.waiting,10),10);
            },
            requires: function(){
                return parseInt(appData.user.documents.required,10) > 0;
            }
        },
        watch: {},
        methods: {

        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon{
        background-color: #ED7003;
        &.warning{
            background-color:$red;
        }
    }
    .documents-to-acknowledge {
        @include clearfix();
        background-color: #ED7003;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;
        &.warning{
            background-color:$red;
        }

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: #ED7003;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #ffdfd3;
            }
        }
    }
</style>
